import * as React from 'react';

export function SvgArrowLeftAlt(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 20,12 A -1,1 0 0 0 19,11 H 5 a -1,1 0 1 0 0,2 h 14 a -1,1 0 0 0 1,-1 z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m 9.707,7.293 a -1,1 0 0 0 -1.414,0 l -4,4 a -1,1 0 0 0 0,1.414 l 4,4 A -1,1 0 0 0 9.707,15.293 L 6.414,12 9.707,8.707 a -1,1 0 0 0 0,-1.414 z"
        fill="currentColor"
      />
    </svg>
  );
}
